import localforage from 'localforage';

localforage.config({
  name: '26MinutesMinistry'
});

export const imageCache = localforage.createInstance({
  name: '26MinutesMinistry_Images'
});

export const cache = {
  get: async (key) => {
    try {
      return await localforage.getItem(key);
    } catch (err) {
      console.error('Cache get error:', err);
      return null;
    }
  },
  set: async (key, value) => {
    try {
      await localforage.setItem(key, value);
    } catch (err) {
      console.error('Cache set error:', err);
    }
  },
  remove: async (key) => {
    await localforage.removeItem(key);
  }
};

const isImageUrl = (url) => {
  if (typeof url !== 'string') return false;
  if (url.startsWith('data:')) return false;
  return /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(url);
};

const getFullUrl = (path) => {
  if (!path) return path;
  if (path.startsWith('http')) return path;
  const baseUrl = process.env.REACT_APP_API_URL?.replace(/\/api\/?$/, '') || '';
  if (path.startsWith('/')) return `${baseUrl}${path}`;
  return path;
};

const cacheImagesInData = async (data) => {
  const urls = new Set();

  const traverse = (obj) => {
    if (!obj) return;
    if (typeof obj === 'string') {
      if (isImageUrl(obj)) urls.add(getFullUrl(obj));
      return;
    }
    if (Array.isArray(obj)) {
      obj.forEach(traverse);
      return;
    }
    if (typeof obj === 'object') {
      Object.values(obj).forEach(traverse);
    }
  };

  traverse(data);

  const promises = Array.from(urls).map(async (url) => {
    try {
      const exists = await imageCache.getItem(url);
      if (!exists) {
        const response = await fetch(url, { credentials: 'include' });
        if (response.ok) {
          const blob = await response.blob();
          await imageCache.setItem(url, blob);
        }
      }
    } catch (err) {
      console.error('Failed to cache image:', url, err);
    }
  });

  // Run in background, don't await strictly
  Promise.allSettled(promises);
};

export const fetchWithCache = async (key, apiCall, setData) => {
  const cachedData = await cache.get(key);
  if (cachedData) {
    setData(cachedData);
  }

  try {
    const networkData = await apiCall();
    setData(networkData);
    await cache.set(key, networkData);
    cacheImagesInData(networkData);
  } catch (error) {
    console.error('Network fetch failed for key:', key, error);
    if (!cachedData) throw error;
  }
};
